const createServiceSchema = ({
  name,
  description,
  url,
  services = []
}) => {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": `${url}#service`,
        "name": name,
        "description": description,
        "url": url,
        "provider": {
          "@id": "https://gurukrupawood.com/#organization"
        },
        "areaServed": {
          "@type": "Country",
          "name": "India"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": `${name} Services`,
          "itemListElement": services.map((service, index) => ({
            "@type": "Offer",
            "position": index + 1,
            "itemOffered": {
              "@type": "Service",
              "name": service.name,
              "description": service.description
            }
          }))
        }
      }
    ]
  };
};

export default createServiceSchema;